import { render, staticRenderFns } from "./ActionBtn.vue?vue&type=template&id=54fe300a"
import script from "./ActionBtn.vue?vue&type=script&lang=js"
export * from "./ActionBtn.vue?vue&type=script&lang=js"
import style0 from "./ActionBtn.vue?vue&type=style&index=0&id=54fe300a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports